import { api } from '~/services/api'

export const fetchAPItoken = async () => {
  return api.get('/v4/api-token')
}

export const generateAPItoken = async (replaceCurrentBoolean = false) => {
  return api.post('/v4/api-token/generate', { replaceCurrentToken: replaceCurrentBoolean })
}
